import {EventLinks} from "../interfaces";
import React from "react";

export  const SeeAlso = (props: any) => {
    const { links } = props;
    return <div className="event-additional-info container">
        <div className="sub-title">Vaata lisaks</div>
        { links.map((link: EventLinks, idx: number) => {
            const url = !link.url.startsWith('http') ? `https://${link.url}` : link.url;
            return <React.Fragment key={idx}>
                { link.url && <div className="link"><a href={link.url}>{link.title || link.url}</a></div> }
            </React.Fragment>
        })}
    </div>
}


